define("settings/components/groups/group-cover", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr class={{if this.connectedAdAccounts.length "tAC--group__row--withAdAccounts"}}>
    {{! Group Details }}
    <td>
      <div class="o--user">
        {{! Group Avatar }}
        <div class="o--user__avatar cNA--group__avatar">
          {{#if @group.imageUrl}}
            <img class="cNA--group__avatar--img" src={{@group.imageUrl}} />
          {{else}}
            <span class="cNA--group__avatar--text">
              {{word-initials @group.name}}
            </span>
          {{/if}}
        </div>
        <div class="u--p__l__xs">
          {{! Group Name }}
          <div class="o--user__title u--ellipsis">
            <span>{{@group.name}}</span>
          </div>
          {{! Group Role }}
          <span class="u--block">
            {{t "account.groups.table.user_count" count=@group.nonContributorMemberCount}}
          </span>
          {{#if this.currentAccount.canContributors}}
            <span class="u--block" data-test-id="contributors count">
              {{t "account.groups.table.contributor_count" count=@group.contributorCount}}
            </span>
          {{/if}}
          {{! Linkin.bio Pages }}
          <span class="u--block">
            {{t "account.groups.table.linkin_bio_page_count" count=this.numberOfLinkinbioPages}}
          </span>
        </div>
      </div>
    </td>
    {{! Social Sets }}
    <td>
      <DragSortList
        @additionalArgs={{hash group=@group}}
        @childClass="cSS--setWrapper"
        @determineForeignPositionAction={{action "determineForeignPosition"}}
        @dragEndAction={{perform this.tradeIdentities}}
        @draggingEnabled={{true}}
        @handle="[draggable]"
        @items={{this.identities}}
        class="parentList"
        as |socialIdentity index|
      >
        <Shared::SocialIdentity
          @clickedDetails={{action "goToDetails"}}
          @editable={{@editable}}
          @index={{index}}
          @socialIdentity={{socialIdentity.identity}}
          @trackProfileTrade={{@trackProfileTrade}}
        />
      </DragSortList>
    </td>
    {{! Action }}
    <td class="at--holisticOnboarding__editButtonCell">
  
      {{#unless @showProfileList}}
        <LinkTo
          @model={{@group}}
          @query={{hash new_social_profile_id=null}}
          @route="groups.group"
          class="o--btn o--btn--outline u--float--right u--p__lr__md qa--settings__editAccessGroup
            {{if
              @isFirstGroup
              'at--autoPublish__socialProfileDetails at--autoPublishEnable__socialProfileDetails at--holisticLibrary__socialSetsAndAccessGroups--editBtn'
            }}"
        >
          {{t "account.groups.table.button"}}
        </LinkTo>
      {{/unless}}
    </td>
  </tr>
  {{#if this.connectedAdAccounts.length}}
    <tr class="tAC--group__adAccountsRow">
      <td class="tAC--group__adAccountsCell" colspan="3">
        <h4 class="tAC--group__adAccountsHeading qa--group__adAccountsHeading">
          {{t "account.groups.table.connected_meta_ad_accounts"}}
        </h4>
        <ul class="tAC--group__adAccounts qa--group__adAccounts">
          {{#each this.connectedAdAccounts as |adAccount|}}
            <li class="tAC--group__adAccount qa--group__adAccount" data-ad-account-id={{adAccount.id}}>
              <span class="tAC--group__adAccount__name">{{adAccount.name}}</span>
              <span aria-hidden="true" class="tAC--group__adAccount__separator">|</span>
              <span class="tAC--group__adAccount__addedBy">
                {{t
                  "account.groups.table.ad_account_added_by"
                  name=(or adAccount.owningUser.name adAccount.owningUser.email)
                }}
              </span>
            </li>
          {{/each}}
        </ul>
      </td>
    </tr>
  {{/if}}
  */
  {
    "id": "gL/pp9MV",
    "block": "[[[10,\"tr\"],[15,0,[52,[30,0,[\"connectedAdAccounts\",\"length\"]],\"tAC--group__row--withAdAccounts\"]],[12],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"o--user__avatar cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,1,[\"imageUrl\"]],[[[1,\"          \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,1,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[[30,1,[\"name\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--p__l__xs\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--user__title u--ellipsis\"],[12],[1,\"\\n          \"],[10,1],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,1],[14,0,\"u--block\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.groups.table.user_count\"],[[\"count\"],[[30,1,[\"nonContributorMemberCount\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"canContributors\"]],[[[1,\"          \"],[10,1],[14,0,\"u--block\"],[14,\"data-test-id\",\"contributors count\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"account.groups.table.contributor_count\"],[[\"count\"],[[30,1,[\"contributorCount\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,1],[14,0,\"u--block\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.groups.table.linkin_bio_page_count\"],[[\"count\"],[[30,0,[\"numberOfLinkinbioPages\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[12],[1,\"\\n    \"],[8,[39,3],[[24,0,\"parentList\"]],[[\"@additionalArgs\",\"@childClass\",\"@determineForeignPositionAction\",\"@dragEndAction\",\"@draggingEnabled\",\"@handle\",\"@items\"],[[28,[37,4],null,[[\"group\"],[[30,1]]]],\"cSS--setWrapper\",[28,[37,5],[[30,0],\"determineForeignPosition\"],null],[28,[37,6],[[30,0,[\"tradeIdentities\"]]],null],true,\"[draggable]\",[30,0,[\"identities\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,7],null,[[\"@clickedDetails\",\"@editable\",\"@index\",\"@socialIdentity\",\"@trackProfileTrade\"],[[28,[37,5],[[30,0],\"goToDetails\"],null],[30,4],[30,3],[30,2,[\"identity\"]],[30,5]]],null],[1,\"\\n    \"]],[2,3]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[14,0,\"at--holisticOnboarding__editButtonCell\"],[12],[1,\"\\n\\n\"],[41,[51,[30,6]],[[[1,\"      \"],[8,[39,9],[[16,0,[29,[\"o--btn o--btn--outline u--float--right u--p__lr__md qa--settings__editAccessGroup\\n          \",[52,[30,7],\"at--autoPublish__socialProfileDetails at--autoPublishEnable__socialProfileDetails at--holisticLibrary__socialSetsAndAccessGroups--editBtn\"]]]]],[[\"@model\",\"@query\",\"@route\"],[[30,1],[28,[37,4],null,[[\"new_social_profile_id\"],[null]]],\"groups.group\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"account.groups.table.button\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"connectedAdAccounts\",\"length\"]],[[[1,\"  \"],[10,\"tr\"],[14,0,\"tAC--group__adAccountsRow\"],[12],[1,\"\\n    \"],[10,\"td\"],[14,0,\"tAC--group__adAccountsCell\"],[14,\"colspan\",\"3\"],[12],[1,\"\\n      \"],[10,\"h4\"],[14,0,\"tAC--group__adAccountsHeading qa--group__adAccountsHeading\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.groups.table.connected_meta_ad_accounts\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"tAC--group__adAccounts qa--group__adAccounts\"],[12],[1,\"\\n\"],[42,[28,[37,11],[[28,[37,11],[[30,0,[\"connectedAdAccounts\"]]],null]],null],null,[[[1,\"          \"],[10,\"li\"],[14,0,\"tAC--group__adAccount qa--group__adAccount\"],[15,\"data-ad-account-id\",[30,8,[\"id\"]]],[12],[1,\"\\n            \"],[10,1],[14,0,\"tAC--group__adAccount__name\"],[12],[1,[30,8,[\"name\"]]],[13],[1,\"\\n            \"],[10,1],[14,\"aria-hidden\",\"true\"],[14,0,\"tAC--group__adAccount__separator\"],[12],[1,\"|\"],[13],[1,\"\\n            \"],[10,1],[14,0,\"tAC--group__adAccount__addedBy\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.groups.table.ad_account_added_by\"],[[\"name\"],[[28,[37,12],[[30,8,[\"owningUser\",\"name\"]],[30,8,[\"owningUser\",\"email\"]]],null]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[8]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@group\",\"socialIdentity\",\"index\",\"@editable\",\"@trackProfileTrade\",\"@showProfileList\",\"@isFirstGroup\",\"adAccount\"],false,[\"if\",\"word-initials\",\"t\",\"drag-sort-list\",\"hash\",\"action\",\"perform\",\"shared/social-identity\",\"unless\",\"link-to\",\"each\",\"-track-array\",\"or\"]]",
    "moduleName": "settings/components/groups/group-cover.hbs",
    "isStrictMode": false
  });
  let GroupCoverComponent = _exports.default = (_class = class GroupCoverComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "router", _descriptor2, this);
      _defineProperty(this, "tradeIdentities", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this = this;
          let {
            sourceList,
            sourceIndex,
            sourceArgs,
            targetArgs,
            targetIndex,
            targetList
          } = _ref;
          return function* () {
            if (targetIndex == undefined) {
              return;
            }
            const incoming = sourceList.objectAt(sourceIndex);
            const didConfirmMove = yield _this.args.trackGroupTrade.perform(incoming);
            if (!didConfirmMove) {
              return;
            }
            sourceList.removeAt(sourceIndex);
            targetList.insertAt(targetIndex, incoming);
            yield sourceArgs.group.set('temporaryIdentities', sourceList);
            yield targetArgs.group.set('temporaryIdentities', targetList);
            sourceArgs.group.set('traded', true);
            targetArgs.group.set('traded', true);
          }();
        }
      }), null, "tradeIdentities", "drop"));
    }
    get currentUser() {
      return this.auth.currentUserModel;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get numberOfLinkinbioPages() {
      return this.args.group.linkinbioPages.length;
    }
    get showMetaAdAccounts() {
      return this.auth.currentAccount?.canUseMetaMarketingApi ?? false;
    }
    get connectedAdAccounts() {
      if (!this.showMetaAdAccounts) return [];
      return (this.args.group.metaAdAccounts || []).toArray?.() ?? this.args.group.metaAdAccounts ?? [];
    }
    get socialIdentities() {
      if (this.args.group.temporaryIdentities) {
        return this.args.group.temporaryIdentities.map(tempIdentity => tempIdentity.identity);
      }
      return this.args.group.socialIdentities || [];
    }
    get identities() {
      const items = [];
      this.socialIdentities.forEach(identity => {
        items.pushObject(_object.default.create({
          identity
        }));
      });
      return items;
    }
    determineForeignPosition(_ref2) {
      let {
        items
      } = _ref2;
      return items.length;
    }
    goToDetails() {
      this.router.transitionTo('account.groups.group', this.args.group.id);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "determineForeignPosition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "determineForeignPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToDetails", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToDetails"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GroupCoverComponent);
});